module.exports = __webpack_public_path__ + "images/emoji/v.a7231b4ab60b64259685.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/v.png
// module id = jfK1
// module chunks = 1